import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/fr-be/messages';
import { messages as retailMessages } from '../translations/autohero-common/fr-be/messages';

activateI18n('es', {
  ...retailMessages,
  ...sellOnlyMessages,
});
